define('plugin/membership/MembershipPlugin',['require','lib/plugin/PluginAbstract','plugin/membership/controller/MembershipController','plugin/membership/collection/MembershipCollection','plugin/membership/collection/ClientBookingMembershipCollection','collection/ServiceCollection','lib/plugin/PluginBroker','plugin/membership/view/MembershipModuleListView','plugin/membership/view/MembershipSelectListView','Config','lib/AppRouter','handlebars','view/helper/TemplatePrecompiled'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var MembershipController = require('plugin/membership/controller/MembershipController');
    var MembershipCollection = require('plugin/membership/collection/MembershipCollection');
    var ClientBookingMembershipCollection = require('plugin/membership/collection/ClientBookingMembershipCollection');
    var ServiceCollection = require('collection/ServiceCollection');
    var PluginBroker = require('lib/plugin/PluginBroker');
    var MembershipModuleListView = require('plugin/membership/view/MembershipModuleListView');
    var MembershipSelectListView = require('plugin/membership/view/MembershipSelectListView');
    var Config = require('Config');
    var AppRouter = require('lib/AppRouter');
    var Handlebars = require('handlebars');
    var templateFor = require('view/helper/TemplatePrecompiled').templateFor;

    return PluginAbstract.extend({

        _membershipModuleRegions: {
            membershipModule: '#sb_membership_module',
            membershipClientButtonModule: '#sb_membership_button_module'
        },
        _membershipDetailsRegions: {
            membershipSelect: '#sb_membership_container'
        },
        _collection: null,
        _clientCollection: null,
        _serviceCollection: null,
        _clientModel: null,
        _clientMembershipCollection: null,
        _multipleBookingCollection: null,
        _detailsStepView: null,

        /**
         * Initializes plugin
         */
        initialize: function () {
            this.initCollection();
            this.initModels();
            this.initRoutes();
            this.initTemplateHelpers();
        },

        initStepManagerEvents: function () {
            this.listenTo(this._stepManager, 'step:render:details', this.beforeDetailsShow);

            this.listenTo(this._stepManager.getBookingModel(), 'change:service_id', this.loadMemberships);
            this.listenTo(this._stepManager.getBookingModel(), 'change:start_date', this.loadMemberships);
            this.listenTo(this._stepManager.getBookingModel(), 'change:dates', this.loadMemberships);
            if (this._multipleBookingCollection) {
                this.listenTo(this._multipleBookingCollection, 'update', this.loadMemberships);
            }

            this.listenTo(this._clientModel, 'sync', this.loadMemberships);
            this.listenTo(this._serviceCollection, 'sync', this.loadMemberships);
        },

        /**
         * Loads client memberships
         */
        loadMemberships: function () {
            var serviceId = this._stepManager.getBookingModel().get('service_id');
            var startDate = this._stepManager.getBookingModel().get('start_date');
            var count = this._stepManager.getBookingModel().get('count');
            if (this._stepManager.getBookingModel().get('dates') && this._stepManager.getBookingModel().get('dates').length > 1) {
                count = this._stepManager.getBookingModel().get('dates').length;
            }

            if (serviceId && startDate) {
                this._clientMembershipCollection.fetch({
                    data: {
                        'service_start_date': startDate,
                        'service_id': serviceId,
                        'count': count
                    }
                });
                this.listenTo(this._clientMembershipCollection, 'sync', this._autoSelectMembership);
            }
        },

        _autoSelectMembership: function () {
            var first = this._clientMembershipCollection.first();
            if (first) {
                this._stepManager.getBookingModel().set('client_membership_id', first.id);
            } else {
                this._stepManager.getBookingModel().set('client_membership_id', null);
            }
        },

        /**
         * Before details step shown add additional fields region
         *
         * @param DetailsStep step
         * @param DetailsView view
         * @param Marionette.Region region
         */
        beforeDetailsShow: function (step, view, region) {
            this._detailsStepView = view;
            _.each(this._membershipDetailsRegions, function (selector, region) {
                view.addRegion(region, selector);
            });

            var selectView = new MembershipSelectListView({
                bookingModel: this._stepManager.getBookingModel(),
                collection: this._clientMembershipCollection,
                error: this._error
            });
            this.listenTo(selectView, 'change:membership', this._selectMembership);

            this._detailsStepView.membershipSelect.show(selectView);

            this._error = null;
        },

        _selectMembership: function (id) {
            this._stepManager.getBookingModel().set('client_membership_id', id);
        },

        /**
         * Initializes collection
         */
        initCollection: function () {
            this._collection = new MembershipCollection();
            this._serviceCollection = new ServiceCollection();
            this._clientMembershipCollection = new ClientBookingMembershipCollection();

            var multipleBookings = PluginBroker.getInstance().getPlugin('multiple_booking');
            if (multipleBookings) {
                this._multipleBookingCollection = multipleBookings.getCollection();
            }

            this._serviceCollection.load();
        },

        /**
         * Initializes models
         */
        initModels: function () {
            this._clientModel = PluginBroker.getInstance().getPlugin('client_login').getClientModel();

            this.listenTo(this._clientModel, 'sync', this.resetClientCollection);
        },

        resetClientCollection: function () {
            this._clientCollection = null;
        },

        /**
         * Initialize plugin modules
         */
        initModules: function (layout) {
            _.each(this._membershipModuleRegions, function (selector, membershipRegion) {
                layout.addRegion(membershipRegion, selector);
            });

            if (layout.membershipModule.$el.length && Config.getInstance().getOption('membership_has_active_memberships')) {
                layout.membershipModule.show(new MembershipModuleListView({
                    collection: this._collection,
                    serviceCollection: this._serviceCollection,
                }));
                this._collection.load();
            }
        },

        /**
         * Inits membership routes
         */
        initRoutes: function () {
            var membershipRouter = new AppRouter({
                appRoutes: {
                    'membership/buy/:id(/)': 'buy',
                    'membership/renew/:id(/)': 'renew',
                    'membership/buy/:id/:date(/)': 'buy',
                    'membership/renew/:id/:date(/)': 'renew',
                    'membership/my(/highlight/:id)(/)': 'myHighlight',
                    'membership/my/status/:status(/)': 'my', //NB status was not used on API side, so we probably don't need this route
                    'membership/my/page/:page(/highlight/:id)(/)': 'myPaginated',
                    'membership(/:id)(/services/:services)(/)': 'index',
                },
                menuItem: 'membership',
                controller: new MembershipController({
                    app: this.getOption('app'),
                    collection: this._collection,
                    serviceCollection: this._serviceCollection,
                    clientModel: this._clientModel
                })
            });
        },

        /**
         * Validates additional fields values
         *
         * @return Boolean
         */
        validate: function () {
            this._validationErrorMessage = null;
            var service = this._stepManager.getBookingModel().get('service');
            if (service && service.memberships && service.memberships.length) {
                if (this._stepManager.getBookingModel().get('client_membership_id')) {
                    return true;
                }

                this._error = 'membership_is_required_error';
                return false;
            } else if (service) {
                return true;
            }
            this._validationErrorMessage = 'Selected event id is not available';
            return false;
        },

        getValidationError: function () {
            return this._validationErrorMessage;
        },

        /**
         * Add membership handlebar helpers
         */
        initTemplateHelpers: function () {
            Handlebars.registerPartial('membership_selected_list', templateFor('#membership_selected_list'));
        }

    });

});
